<template>
  <div class="dft-d-container" :style="[container_Style]">
    <div class="dft-shelfasset_box orderTitle" :style="[orderTitle_Style]">
      我的订单
    </div>
    <div class="dft-shelfasset_box" v-if="model == '2'" :style="[shelfasset_box_Style]">
      <div class="dft-shelfasset_bottom" :style="[shelfasset_bottom_item_style,shelfasset_bottom_item_style_down]">
        <div class="dft-shelfasset_bottom_item" v-for="(item,index) in infolist.filter(item=>item.show == true)" :key="index">
          <div class="orderimg_box">
            <div class="badge_num">
              {{item.value}}
            </div>
            <el-image class="img_class" :src="item.img" fit="scale-down"></el-image>
          </div>
          <div class="" style="font-size: 14px;">
            {{item.name}}
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>

export default {
  props: {
    compData: {
      type: [Array, Object],
      default: () => []
    }
  },
  options: {
    styleIsolation: 'shared' // 解除样式隔离
  },
  data () {
    return {
      showDialog: false
    }
  },
  watch: {
    compData: {
      handler: function (newVal) {
        if (newVal) {
          this.$nextTick(() => {
            // console.log('comp--D-ata--0',newVal)
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    model () {
      return this.compData?.attr?.a2?.value
    },
    styletype () {
      return this.compData?.attr?.a3?.value
    },
    infolist () {
      return this.compData?.attr?.a4?.value
    },
    infolistNum () {
      return this.compData?.attr?.a4?.value.filter(item => item.show == true).length || 0
    },
    infoactive () {
      return this.compData?.attr?.a4?.value[this.compData?.attr?.a4?.activeIndex]
    },
    cardstyle () {
      return this.compData?.attr?.a5?.value
    },
    texticoncolor () {
      return this.compData?.attr?.a7?.value
    },
    addimage () {
      return this.compData?.attr?.a15?.value
    },
    // 样式
    container_Style () {
      return {
        'padding': `4px ${this.compData?.attr?.['a13']?.value}px`,
        'background': this.compData?.attr?.['a8']?.value
      }
    },
    // 标题自定义样式
    orderTitle_Style() {
      return {
        'color': this.compData?.attr?.['a7']?.value,
        'border-radius': this.compData?.attr?.['a12']?.value,
        'box-shadow': this.cardstyle == '2' ? '0 2px 12px rgba(100, 101, 102, .12)' : 'unset',
      }
    },
    shelfasset_box_Style () {
      return {
        'color': this.compData?.attr?.['a7']?.value,
        'border-radius': this.compData?.attr?.['a12']?.value,
        'box-shadow': this.cardstyle == '2' ? '0 2px 12px rgba(100, 101, 102, .12)' : 'unset',
        'border': this.cardstyle == '3' ? '1px solid #ebedf0' : 'none',
        'overflow': 'hidden',
      }
    },
    shelfasset_image_style () {
      switch (this.model) {
        case '2':
          return {
            'width': '48px',
            'height': '48px'
          }
        case '4':
          return {
            'width': '42px',
            'height': '42px'
          }
        default:
          return {}
      }
    },
    shelfasset_text_style () {
      return {
        // 'font-size': `${this.compData?.attr?.['a9']?.value}px`,
      }
    },
    shelfasset_bottom_item_style () {
      return {
        'grid-template-columns': `repeat(${this.infolistNum}, 1fr)`
      }
    },
    shelfasset_bottom_item_style_down () {
      return {
        'background': this.cardstyle == '4' ? 'transparent' : this.compData?.attr?.['a11']?.value,
        'padding': '10px 0'
      }
    }
  },
  created () {
  },

  mounted () {
    this.$nextTick(() => {
    })
  },

  methods: {
    initData () {
    }
  }
}
</script>

<style lang="scss" scoped>
.dft-d-container{
  width: 100%;
  height: auto;
  padding: 0;
  box-sizing: border-box;
}
.dft-shelfasset_box{
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  font-size: 13px;
  &::-webkit-scrollbar {
    height: 0px;
  }
}
.dft-shelfasset_box1{
  display: flex;
  .dft-shelfasset_image{
    margin: 0;
  }
  .dft-shelfasset_name,.dft-shelfasset_text{
    justify-content: center;
    text-align: center;
  }
}
.dft-shelfasset_item{
  box-sizing: border-box;
  display: flex;
  align-items: center;
  position: relative;
  padding: 10px;
}
.dft-shelfasset_image{
  width: 60px;
  height: 60px;
  border-radius: 50%;
  flex-shrink: 0;
  overflow: hidden;
  margin-right: 10px;
}
.dft-shelfasset_infobox{
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.dft-shelfasset_info{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.dft-shelfasset_name{
  display: flex;
  align-items: center;
  text-align: left;
  width: 100%;
  height: 24px;
  font-size: 15px;
  line-height: 24px;
}
.dft-shelfasset_text{
  display: flex;
  display: -webkit-box;
  justify-content: center;
  align-items: center;
  text-align: left;
  font-size: 12px;
  width: 100%;
  height: 20px;
  line-height: 20px;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.dft-scan_box{
  font-size: 11px;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 4px 12px;
  margin-top: 5px;
  border-radius: 10px;
  box-sizing: border-box;
  background: #ff3333;
  text-align: center;
  color: #fff;
}
.dft-shelfasset_scan{
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  box-sizing: border-box;
}
.dft-shelfasset_scan_info{
  font-size: 12px;
}
.dft-shelfasset_bottom{
  display: grid;
  .dft-shelfasset_bottom_item{
    padding: 0 12px;
    margin: 12px 0 6px;
    box-sizing: border-box;
    border-left: 1px solid #ddd;
    display: flex;
    flex-direction: column;
    align-items: center;
    &:first-of-type{
      border-left: none;
    }
  }
}
.img_class{
  display: block;
  width: 100%;
  height: 100%;
}
/deep/.image-slot{
  width: 100%;
  height: 100%;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dft-right{
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  .dft-right_p{
    width: 100%;
    height: 50%;
    box-sizing: border-box;
    padding: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
  }
  .dft-right_top{
    width: 100px;
    height: 100px;
  }
  .dft-right_bottom{
    width: 100px;
    height: 100px;
  }
}
.orderTitle{
  font-size: 16px;
  font-weight: bold;
  padding: 18px 0 12px;
  border-bottom: 1px solid #f3f3f3;
}
.orderimg_box{
  min-width: 36px;
  min-height: 36px;
  width: 36px;
  height: 36px;
  position: relative;
  .badge_num{
    position: absolute;
    top: -8px;
    right: -8px;
    width: 16px;
    height: 16px;
    font-size: 11px;
    line-height: 20px;
    color: #fff;
    background: #ff4444;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
